export enum SortKeyForKeycloakUser {
  ID = 'ID',
  FIRST_NAME = 'FIRST_NAME',
  LAST_NAME = 'LAST_NAME',
  EMAIL = 'EMAIL',
  CUSTOMER_ID = 'CUSTOMER_ID',
  USER_SUB = 'USER_SUB',
}
